/* istanbul ignore file */
import { optional as codecOptional, string as codecString } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const ConfirmPendingRegistrationDataParser = 
/* #__PURE__ */ parsers.object([
    ['code', codecString],
    ['username', codecString],
    ['name', codecString],
    ['password', /* #__PURE__ */ codecOptional(codecString)],
]);
export class ConfirmPendingRegistrationData extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return ConfirmPendingRegistrationDataParser.decode(input).map(res => new ConfirmPendingRegistrationData(res));
    }
    static unsafeDecode(input) {
        return ConfirmPendingRegistrationData.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return ConfirmPendingRegistrationDataParser.encode(data);
    }
    static schema() {
        return ConfirmPendingRegistrationDataParser.schema();
    }
}
